'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  border-bottom: 1px solid ', ';\n  border-top: 1px solid ', ';\n  color: ', ';\n  font-size: ', ';\n  font-style: italic;\n  line-height: ', ';\n  margin-bottom: ', ';\n  margin-left: auto;\n  margin-right: auto;\n  margin-top: ', ';\n  max-width: calc(100% - 60px);\n  padding: 10px;\n  text-align: center;\n\n  ', '\n'], ['\n  border-bottom: 1px solid ', ';\n  border-top: 1px solid ', ';\n  color: ', ';\n  font-size: ', ';\n  font-style: italic;\n  line-height: ', ';\n  margin-bottom: ', ';\n  margin-left: auto;\n  margin-right: auto;\n  margin-top: ', ';\n  max-width: calc(100% - 60px);\n  padding: 10px;\n  text-align: center;\n\n  ', '\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _rem = require('polished/lib/helpers/rem');

var _rem2 = _interopRequireDefault(_rem);

var _config = require('../../config.js');

var _mixins = require('../../mixins');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Container = _styledComponents2.default.p(_templateObject, _config.colors.darkRed, _config.colors.darkRed, _config.colors.darkGray, (0, _rem2.default)('32px', _config.typography.baseFontSize), (0, _rem2.default)('32px', _config.typography.baseFontSize), function (props) {
  return props.hasBottomMargin ? '30px' : '0';
}, function (props) {
  return props.hasTopMargin ? '30px' : '0';
}, function (props) {
  return props.hasTopMargin || props.hasBottomMargin ? (0, _mixins.ClearFix)() : '';
});

Container.displayName = 'Container';

/**
# Pull Quote
A brief, attention-catching quotation, typically in a distinctive typeface,
taken from the main text of an article and used as a subheading or graphic
feature.
 */
var PullQuote = function PullQuote(_ref) {
  var hasBottomMargin = _ref.hasBottomMargin,
      hasTopMargin = _ref.hasTopMargin,
      text = _ref.text;
  return _react2.default.createElement(
    Container,
    {
      hasBottomMargin: hasBottomMargin,
      hasTopMargin: hasTopMargin
    },
    text
  );
};

PullQuote.propTypes = {
  /** Whether or not a 30px bottom margin is applied. */
  hasBottomMargin: _propTypes2.default.bool,
  /** Whether or not a 30px top margin is applied. */
  hasTopMargin: _propTypes2.default.bool,
  /** The text to go inside the quote */
  text: _propTypes2.default.string.isRequired
};

PullQuote.defaultProps = {
  hasBottomMargin: true,
  hasTopMargin: true
};

PullQuote.displayName = 'PullQuote';

exports.default = PullQuote;
PullQuote.__docgenInfo = {
  'description': '# Pull Quote\r\nA brief, attention-catching quotation, typically in a distinctive typeface,\r\ntaken from the main text of an article and used as a subheading or graphic\r\nfeature.',
  'methods': [],
  'displayName': 'PullQuote',
  'props': {
    'hasBottomMargin': {
      'defaultValue': {
        'value': 'true',
        'computed': false
      },
      'type': {
        'name': 'bool'
      },
      'required': false,
      'description': 'Whether or not a 30px bottom margin is applied.'
    },
    'hasTopMargin': {
      'defaultValue': {
        'value': 'true',
        'computed': false
      },
      'type': {
        'name': 'bool'
      },
      'required': false,
      'description': 'Whether or not a 30px top margin is applied.'
    },
    'text': {
      'type': {
        'name': 'string'
      },
      'required': true,
      'description': 'The text to go inside the quote'
    }
  }
};